import React from 'react';

interface typeProps {
  name: string;
  label: string;
  type: string;
  placeholder: string;
  data: any;
  setData: Function;
  required?: boolean;
  disabled?: boolean;
  className?: string
}

const Input = ({
  name,
  label,
  type,
  placeholder,
  data,
  setData,
  required,
  disabled,
  className,
}: typeProps) => {
  return (
    <div className={`field ${className}`}>
      <label htmlFor="label">{label}:</label>
      <input
        type={type}
        id={name}
        value={data}
        name={name}
        onChange={(event: any) => {
          setData(event);
        }}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
      />
    </div>
  );
};

export default Input;
